<script>
	import { onNavigate } from '$app/navigation';
	import Livechat from '$lib/Components/LiveChat/LiveChat.svelte';
	import PageMeta from '$lib/Components/PageMeta/PageMeta.svelte';
	import Title from '$lib/Components/PageTitle/PageTitle.svelte';
	import { getCookie } from '$lib/cookies';
	// import { webVitals } from '$lib/Components/Vercel/SpeedInsights/SpeedInsights.js';
	import Footer from '$lib/PageSections/Footer/Footer.svelte';
	import { getContext, onMount } from 'svelte';

	let { children } = $props();

	let userData = getContext('userData');

	onMount(() => {
		userData.signedIn = userData?.contact?.email ?? getCookie('signed_in');
	});

	// import { env } from '$env/dynamic/public';
	// const BROWSER = typeof window !== 'undefined';

	// let inject;
	// async function injectVercelAnalytics() {
	// 	inject = await (await import('@vercel/analytics')).inject;
	// 	inject({
	// 		mode: 'production',
	// 	});
	// }
	// if (BROWSER && env.VERCEL_ANALYTICS_ID) {
	// 	injectVercelAnalytics();
	// }

	// afterNavigate(() => {
	// 	if (BROWSER && env.VERCEL_ANALYTICS_ID) {
	// 		webVitals({
	// 			analyticsId: env.VERCEL_ANALYTICS_ID,
	// 		});
	// 	}
	// });

	onNavigate((navigation) => {
		if (!document.startViewTransition) {
			return;
		}

		if (
			(navigation?.from?.url?.pathname == '/products/indowone-window-inserts' &&
				(navigation?.to?.url?.pathname == '/products/thermal-window-inserts' ||
					navigation?.to?.url?.pathname ==
						'/products/acoustic-window-inserts' ||
					navigation?.to?.url?.pathname ==
						'/products/uv-blocking-window-inserts' ||
					navigation?.to?.url?.pathname == '/products/sleep-panels' ||
					navigation?.to?.url?.pathname == '/products/privacy-inserts' ||
					navigation?.to?.url?.pathname ==
						'/products/commercial-window-inserts')) ||
			(navigation?.to?.url?.pathname == '/products/indowone-window-inserts' &&
				(navigation?.from?.url?.pathname ==
					'/products/thermal-window-inserts' ||
					navigation?.from?.url?.pathname ==
						'/products/acoustic-window-inserts' ||
					navigation?.from?.url?.pathname ==
						'/products/uv-blocking-window-inserts' ||
					navigation?.from?.url?.pathname == '/products/sleep-panels' ||
					navigation?.from?.url?.pathname == '/products/privacy-inserts' ||
					navigation?.from?.url?.pathname ==
						'/products/commercial-window-inserts'))
		) {
			return new Promise((resolve) => {
				document.startViewTransition(async () => {
					resolve();
					await navigation.complete;
				});
			});
		}
	});
</script>

<PageMeta />

<main class="content-grid">
	<Title />
	{@render children?.()}
</main>
<Footer />

<Livechat />

<style>
	main {
		height: inherit;
		flex: 1;
		place-items: normal;
		display: flex;
		flex-flow: column;
	}
	:root {
		scroll-padding-top: 8rem;
	}
	@media (min-width: 768px) {
		:root {
			scroll-padding-top: 1rem;
		}
	}
</style>
